/**
 * SBN v1 字母表与头部编解码。
 * 依据 docs/sbn-v1-format.md 第 1、3 节实现。
 */

/** 6 位分组字母表，索引 0..63。末两位是 URL 安全的 `-` `_`。 */
export const ALPHABET =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_';

/** 字符 → 索引。非法字符查得 undefined。 */
const charToInt = new Map();
for (let i = 0; i < ALPHABET.length; i++) charToInt.set(ALPHABET[i], i);

/** @param {string} ch @returns {number} 索引，非法返回 -1 */
export function charValue(ch) {
    const v = charToInt.get(ch);
    return v === undefined ? -1 : v;
}

/** @param {number} v 0..63 @returns {string} */
export function valueChar(v) {
    return ALPHABET[v];
}

export const MIN_DIM = 4;
export const MAX_DIM = 25;

/** 标志位：无玩家标注。 */
export const FLAG_NONE = 'W';
/** 标志位：base4 玩家标注。 */
export const FLAG_BASE4 = 'e';
/** 标志位：base8 玩家标注。 */
export const FLAG_BASE8 = 'f';

const VALID_FLAGS = new Set([FLAG_NONE, FLAG_BASE4, FLAG_BASE8]);

/** @param {string} flag */
export function isValidFlag(flag) {
    return VALID_FLAGS.has(flag);
}

/**
 * dim → 2 字符尺寸码（同一字符重复两次）。
 * @param {number} dim 4..25
 * @returns {string}
 */
export function dimToCode(dim) {
    if (!Number.isInteger(dim) || dim < MIN_DIM || dim > MAX_DIM) {
        throw new RangeError(`dim 超出 ${MIN_DIM}..${MAX_DIM}: ${dim}`);
    }
    const ch = ALPHABET[dim];
    return ch + ch;
}

/**
 * 2 字符尺寸码 → dim。两字符必须相同且索引落在合法区间。
 * @param {string} code
 * @returns {number} dim，非法返回 -1
 */
export function codeToDim(code) {
    if (code.length !== 2 || code[0] !== code[1]) return -1;
    const dim = charValue(code[0]);
    if (dim < MIN_DIM || dim > MAX_DIM) return -1;
    return dim;
}

/**
 * 边界位数与所需字符数。
 * @param {number} dim
 */
export function borderSizes(dim) {
    const bits = 2 * dim * (dim - 1);
    return { bits, chars: Math.ceil(bits / 6) };
}
